import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import lang_en from './translations/en.json';
import lang_de from './translations/de.json';


const resources = {
   en:{translation: lang_en},
   de:{translation: lang_de},
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'de',
  interpolation:{
    escapeValue: false
  }
});

export default i18n; 
